import { Star } from 'lucide-react';

/**
 * StarBadge — reusable 1..3 star display for level results / level cards.
 * `count` = filled stars (0..3). `max` = total slots (default 3).
 */
export default function StarBadge({ count = 0, max = 3, size = 14, className = '', testid = 'star-badge' }) {
  return (
    <div className={`inline-flex items-center gap-0.5 ${className}`} data-testid={testid}>
      {Array.from({ length: max }, (_, i) => {
        const filled = i < count;
        return (
          <Star
            key={i}
            size={size}
            strokeWidth={1.8}
            className={filled ? 'text-gold fill-gold' : 'text-white/25'}
            fill={filled ? 'currentColor' : 'none'}
          />
        );
      })}
    </div>
  );
}
